/**
 * add accordion functionality for menu items to .s-footer selector
 */
import jQuery from 'jquery'
import * as lib from './../lib/lib'

export default class VehicleTabs {
  constructor(element) {
    if (!element) {
      return false
    }

    this.$element = jQuery(element)
    this.categories = jQuery('.s-vehicle-tabs__item', this.$element)
    this.categoryLinksClassName = '.s-vehicle-tabs__item > a'
    this.accordions = jQuery('.s-vehicle-tabs__accordion', this.$element)
    this.gallery = jQuery('.s-vehicle-tabs__items', this.$element)
    this.slckopts = {
      swipe: false,
      dots: false,
      arrows: true,
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: false,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 768,
          settings: {
            arrows: true,
            slidesToShow: 2,
          },
        },
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ],
    }

    if (lib.scrDevices()) {
      this._unSlick()
    } else {
      this._iniSlick()
    }

    this._setCategoryClick()

    this._setDefaultValues()

    jQuery(window).on('resize', () => {
      clearTimeout(window.resizedFinished)
      window.resizedFinished = setTimeout(() => {
        if (lib.scrDevices()) {
          this._unSlick()
        } else {
          this._iniSlick()
        }
      }, 250)
    })
  }

  _setDefaultValues() {
    this.categories.eq(0).find('> a').addClass('is-active')
    this.accordions.eq(0).addClass('is-active')
  }

  _setCategoryClick() {
    jQuery(document).on('click', this.categoryLinksClassName, (e) => {
      const targetElement = jQuery(e.currentTarget)

      jQuery(this.categoryLinksClassName).removeClass('is-active')
      targetElement.addClass('is-active')

      const index = targetElement.data('index')
      this.accordions.removeClass('is-active')
      this.accordions.eq(index).addClass('is-active')
    })
  }

  _iniSlick() {
    if (!this.gallery.hasClass('slick-initialized')) {
      this.gallery.slick(this.slckopts)
    }
  }

  _unSlick() {
    if (this.gallery.hasClass('slick-initialized')) {
      this.gallery.slick('unslick')
    }
  }
}
